import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import { getGeoLocationData } from 'reduxUtils/modules/geo';
import InViewObserver from 'components/InViewObserver';
import Weather from '../../components/Weather';
import { getWeatherData, fetchWeatherData } from './redux';
import { iconsMap } from './config';
import utils from './WeatherUtil';
//import stringUtils from '../../utils/string';

class WithWeather extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weatherData: null,
    };
  }
  setWeatherData(geoData, forceCity) {
    let geodata = {};
    geodata = geoData;
    geodata.city = geoData.city;
    if (forceCity) {
      //fetch data & store in Component state
      //to store local weather
      fetchWeatherData(geodata).then(data => {
        const weatherData = utils.filterData(data.data);
        this.setState({
          weatherData,
        });
      });
    } else {
      //fetch data & store in Redux for entire page
      if (this.state.weatherData !== null) {
        this.setState({ weatherData: null });
      }
      this.props.getWeatherData(geodata);
    }
  }

  setWeatherDataApi = () => {
    const weatherData = this.state.weatherData || this.props.weatherData;
    if (!weatherData && this.props.geoCityData) {
      this.setWeatherData(this.props.geoCityData);
    }
  };

  componentDidMount() {
    const { lazyload } = this.props;
    if (!lazyload) {
      this.setWeatherDataApi();
    }
  }

  componentDidUpdate(prevProps) {
    // const { forcedCity } = this.props;
    const { geoCityData, forceCity } = this.props;
    // const city = forcedCity || _get(geoCityData, 'city');
    const city = _get(geoCityData, 'city');
    // const prevCity =
    //   prevProps.forcedCity || _get(prevProps.geoCityData, 'city');
    const prevCity = _get(prevProps.geoCityData, 'city');
    const prevForceCity = _get(prevProps, 'forceCity');
    if (city && city !== prevCity) {
      this.setWeatherData(geoCityData);
    } else if (forceCity && forceCity !== prevForceCity && forceCity !== city) {
      this.updateGeoAndWeatherData(forceCity);
    }
  }

  async updateGeoAndWeatherData(city) {
    const data = await getGeoLocationData(city);
    if (data.data) {
      this.setWeatherData(data.data, true);
    }
  }

  renderComponent = () => {
    const weatherData = this.state.weatherData || this.props.weatherData;
    const geoData = this.props.geoCityData;
    if (!weatherData && geoData && !this.props.lazyload) {
      this.setWeatherData(geoData);
      return null;
    }
    return (
      <>
        {geoData && weatherData ? (
          <Weather
            data={weatherData}
            cityname={this.props.forceCity || geoData.city}
            iconsMap={iconsMap}
            isToggleRequired="NO"
            isWapView={this.props.isWapView}
            isWeatherInC={
              geoData &&
              geoData.countryCode &&
              geoData.countryCode.toLowerCase() === 'in'
                ? true
                : this.props.isWeatherInC
            }
            colorTheme={this.props.colorTheme}
            hideCityName={this.props.hideCityName}
            addExtraClass={this.props.addExtraClass}
          />
        ) : (
          ''
        )}
      </>
    );
  };

  render() {
    const { lazyload = false } = this.props;
    return (
      <>
        {lazyload ? (
          <InViewObserver
            inViewCallback={() => {
              this.setWeatherDataApi();
            }}
            viewMargin="300px 0px 300px 0px"
          >
            {this.renderComponent()}
          </InViewObserver>
        ) : (
          this.renderComponent()
        )}
      </>
    );
  }
}

const mapStateToProps = state => ({
  weatherData: state.weather.weatherData,
  //geo: state.geo,
  geoCityData: state.geo.cityData,
  // geoStateData: state.geo.stateData,
});

const mapDispatchToProps = dispatch => ({
  getWeatherData: params => {
    dispatch(getWeatherData(params));
  },
});

WithWeather.propTypes = {
  getWeatherData: PropTypes.func.isRequired,
  weatherData: PropTypes.shape({}),
  geoCityData: PropTypes.shape({
    city: PropTypes.string,
  }),
  isWapView: PropTypes.bool,
  isWeatherInC: PropTypes.bool,
  colorTheme: PropTypes.string,
  hideCityName: PropTypes.bool,
  addExtraClass: PropTypes.string,
  lazyload: PropTypes.bool,

  // geo: PropTypes.shape({
  //   cities: PropTypes.shape({}),
  //   currentCity: PropTypes.string,
  // }),
};

WithWeather.defaultProps = {
  weatherData: null,
  // geo: undefined,
  geoCityData: undefined,
  // geoStateData: undefined,
  isWapView: false,
  isWeatherInC: true,
  colorTheme: '',
  hideCityName: false,
  addExtraClass: '',
  lazyload: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(WithWeather);
